import * as React from 'react';
import { CenteredContentLayout } from '../../../components/containers/CenteredContentLayout';
import { LegacyIframeOptions, useLegacyIframe } from '../../../hooks/useLegacyIframe';
import { BoxNotification } from '../../../components/containers/BoxNotification';
import { useLocation } from 'react-router-dom';
import { SubscriptionStatus } from 'models/graphql';

const URL_SRC_PLAN_LIMITS = 'plan_limit_reached';

const iframeUrlMap = {
  [SubscriptionStatus.EXPIRED]: '/pricing/renew_expired_subscription',
  [SubscriptionStatus.PAID]: '/pricing',
  [SubscriptionStatus.PAST_DUE]: '/pricing/renew_past_due_subscription',
  [SubscriptionStatus.TRIAL]: '/pricing/upgrade_in_trial'
};

const isSubscriptionStatus = (status: any): status is SubscriptionStatus => {
  return Object.values(SubscriptionStatus).includes(status);
};

export const SubscriptionView = (): JSX.Element => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const sourceRedirect = params.get('src') as string | null;
  const limitThatWasReached = params.get('limit') as string | null;
  const contextLimit = params.get('context') as string | null;
  const status = params.get('status');
  let urlIframe =
    sourceRedirect === URL_SRC_PLAN_LIMITS
      ? `https://${window.location.hostname}/pricing?src=plan_limit_reached&limit=${limitThatWasReached}${
          contextLimit ? '&context=' + contextLimit : ''
        }`
      : `https://${window.location.hostname}/settings/subscription`;

  if (isSubscriptionStatus(status)) {
    urlIframe = `https://${window.location.hostname}${iframeUrlMap[status]}`;
  }

  const options: LegacyIframeOptions = {
    title: 'Subscription Management',
    src: urlIframe,
    whiteListedPaths: [/^\/checkout/, /^\/pricing/, /^\/settings\/subscription/, /^\/contact/, /^\/business_details/],
    allow: 'payment'
  };
  const { loading, error, iframe } = useLegacyIframe(options);

  return (
    <>
      {loading && (
        <CenteredContentLayout loading={true} hasSidebar>
          <></>
        </CenteredContentLayout>
      )}
      {error && (
        <CenteredContentLayout hasSidebar>
          <div className={'grid-x margin-top-small-32'}>
            <BoxNotification type={'error'}>Sorry, something went wrong loading this content</BoxNotification>
          </div>
        </CenteredContentLayout>
      )}
      {!error && iframe}
    </>
  );
};
